<template>
    <div
        class="search-container borderOpacity rounded-8 overflow-hidden ppv2-flex ppv2-items-center ppv2-relative"
        :class="{ expanded: showSearchInput }"
    >
        <!-- Champ de recherche -->
        <input
            ref="searchInput"
            v-model="searchQuery"
            type="text"
            :placeholder="$t('common.search')"
            class="search-input ppv2-bg-transparent ppv2-text-white ppv2-text-sm ppv2-outline-none ppv2-border-none ppv2-w-full ppv2-px-3"
            @keyup.enter="performSearch"
            @blur="hideSearchInput"
            @input="emitSearch"
        />

        <!-- Icône -->
        <div
            class="search-icon ppv2-absolute ppv2-right-0 ppv2-top-0 ppv2-bottom-0 ppv2-flex ppv2-items-center ppv2-justify-center ppv2-w-[40px] cursor-pointer transition-all duration-300 ease-in-out hover:ppv2-bg-[#ffffff17]"
            @click="toggleSearchInput"
        >
            <SearchIcon color="white" size="14" />
        </div>
    </div>
</template>

<script setup>
import { SearchIcon } from 'vue-feather-icons'
import { ref, nextTick } from 'vue'
import { EventBus } from '../../../../eventBus.js'
const showSearchInput = ref(false)
const searchQuery = ref('')
const searchInput = ref(null)

const toggleSearchInput = () => {
    showSearchInput.value = !showSearchInput.value
    if (showSearchInput.value) nextTick(() => searchInput.value?.focus())
}

const hideSearchInput = () => {
    setTimeout(() => (showSearchInput.value = false), 200)
}

const performSearch = () => {
    if (searchQuery.value.trim()) console.log('🔍 Recherche :', searchQuery.value)
    showSearchInput.value = false
    searchQuery.value = ''
}
const emitSearch = () => {
    EventBus.$emit('search-updated', searchQuery.value)
}
</script>

<style scoped>
.borderOpacity {
    border: 0.58px solid #e2e8f066;
}

/* --- Conteneur animé --- */
.search-container {
    width: 40px;
    height: 32px;
    transition: width 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    background: transparent;
    position: relative;
}
.search-container.expanded {
    width: 220px;
}

/* --- Animation input --- */
.search-input {
    opacity: 0;
    transform: translateX(-10px);
    transition:
        opacity 0.35s ease,
        transform 0.35s ease;
}
.search-container.expanded .search-input {
    opacity: 1;
    transform: translateX(0);
}

/* --- Icône de recherche --- */
.search-icon {
    transition:
        background-color 0.3s ease,
        transform 0.3s ease;
}
.search-icon:hover {
    transform: scale(1.1);
}

/* --- Placeholder doux --- */
.search-input::placeholder {
    color: #a0aec0;
    opacity: 0.7;
}
</style>
